/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { useState, useEffect, useCallback, useRef } from 'react'
import { useHistory } from 'react-router-dom'
import { FormHandles } from '@unform/core'
import { Form } from '@unform/web'
import { FiInfo, FiMail, FiSmartphone, FiUser } from 'react-icons/fi'
import * as Yup from 'yup'
import { MdSecurity } from 'react-icons/md'
import usePersistedState from '../../hooks/usePersistedState'
import calculaIdade from '../../utils/calculaIdade'
import Header from '../../components/Header'
import Button from '../../components/Button'
import { UserData, UserDetails, Participant } from '../../utils/interfaces'
import {
  Content,
  BtnVoltar,
  Participants,
  InfoContent,
  RadioButton,
  BtnOption,
  BtnModal,
} from './styles'
import ModalBox from '../../components/Modal'
import Input from '../../components/Input'
import getValidationErrors from '../../utils/getValidationErrors'
import Container from '../../components/Container'
import Line from '../../components/Line'
import { formatValue } from '../../utils/formatValues'

const Resume: React.FC = () => {
  const [userData, setUserData] = usePersistedState<UserData>(
    'userData',
    {} as UserData,
  )
  const [userDetails, setUserDetails] = usePersistedState<UserDetails>(
    'userDetails',
    {} as UserDetails,
  )

  const [participants] = usePersistedState<Participant[]>(
    'participantsGroup',
    [],
  )

  const [, setFlagEdit] = usePersistedState<'S' | 'N' | ''>('flagEdit', 'N')

  const [flagSimulation] = usePersistedState('flagSimul', false)
  const [tipCtbAdic] = usePersistedState('tipCtbAdic', '') // P = Percentual sobre o salário || F = Valor fixo

  const [aguarde] = useState(false)
  const [timer, setTimer] = useState(0)
  const [reSend, setReSend] = useState(true)
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [isModalPEPOpen, setIsModalPEPOpen] = useState(false)
  const [warningText] = useState('')

  const formRef = useRef<FormHandles>(null)

  function handleCloseModal(): void {
    setIsModalOpen(false)
  }

  function handleCloseModalPEP(): void {
    setIsModalPEPOpen(false)
  }
  const history = useHistory()

  const handleSubmit = useCallback(
    async data => {
      try {
        formRef.current?.setErrors({})
        const schema = Yup.object().shape({
          email: Yup.string()
            .email('Digite um e-mail válido')
            .required('E-mail obrigatório'),
          phone: Yup.string()
            .max(15, 'Telefone inválido')
            .min(14, 'Telefone inválido')
            .required('Celular obrigatório'),
        })

        await schema.validate(data, { abortEarly: false })

        await setUserData({
          ...userData,
          email: data.email,
          phone: data.phone,
          parental: data.parental,
        })

        localStorage.removeItem('@BASF:flagEdit')

        history.push('/conclusion')
      } catch (err) {
        formRef.current?.setErrors(
          getValidationErrors(err as Yup.ValidationError),
        )
      }
    },
    [setUserData, userData, history],
  )

  const dependents = participants.filter(
    participant => participant.details.grauParentesco !== undefined,
  )

  useEffect(() => {
    const countTimer = (): void => {
      if (timer > 1) {
        setTimer(timer - 1)
      } else if (timer === 1) {
        setTimer(timer - 1)
        setReSend(true)
      }
    }
    const interval = setInterval(countTimer, 1000)
    return () => clearInterval(interval)
  }, [timer])

  const goback = useCallback(
    async e => {
      await setFlagEdit('S')

      if (e === 'S') {
        flagSimulation
          ? history.push('/contribution')
          : history.push('/accession')
      } else if (e === 'b') {
        history.push('/beneficiary')
      } else if (e === 'V') {
        participants.length > 0
          ? history.push('/beneficiary')
          : history.push('/has-beneficiaries')
      }
    },
    [flagSimulation, history, participants.length, setFlagEdit],
  )

  const handleConfirmar = useCallback(event => {
    event.preventDefault()
    formRef.current?.submitForm()
  }, [])

  return (
    <>
      <Header />
      <Container>
        <Content>
          <Form
            onSubmit={handleSubmit}
            ref={formRef}
            initialData={{
              name: userData.name,
              cpf: userData.cpf,
              // matricula: userData.matricula,
              phone: userData.phone,
              email: userData.email,
            }}
          >
            <strong>Resumo de Adesão</strong>
            <Participants>
              <h4>Dados pessoais</h4>
              <div className="titular">
                <Input
                  name="name"
                  placeholder="nome"
                  sizeBox="small"
                  icon={FiUser}
                  disabled
                />
                <Input
                  placeholder="CPF"
                  name="cpf"
                  icon={MdSecurity}
                  type="tel"
                  mask="cpf"
                  sizeBox="small"
                  disabled
                />
                {/* <Input
                  placeholder="Matrícula"
                  name="matricula"
                  icon={BiIdCard}
                  type="number"
                /> */}
                <Input
                  name="phone"
                  mask="phone"
                  placeholder="Celular com DDD"
                  icon={FiSmartphone}
                  sizeBox="small"
                />
                <Input
                  icon={FiMail}
                  name="email"
                  type="email"
                  placeholder="E-mail"
                  sizeBox="small"
                />
              </div>
            </Participants>

            <Line />

            <Participants>
              <h4>Informações adicionais</h4>
              <RadioButton>
                <div className="placeholder">
                  <label>Pessoa politicamente exposta (PPE)?</label>
                  <FiInfo size={20} onClick={() => setIsModalPEPOpen(true)} />
                </div>
                <div className="options">
                  <BtnOption
                    type="button"
                    isActive={userDetails.pep === 'S'}
                    onClick={() => {
                      setUserDetails({
                        ...userDetails,
                        pep: 'S',
                      })
                    }}
                  >
                    Sim
                  </BtnOption>
                  <BtnOption
                    type="button"
                    isActive={userDetails.pep === 'N'}
                    onClick={() => {
                      setUserDetails({
                        ...userDetails,
                        pep: 'N',
                      })
                    }}
                  >
                    Não
                  </BtnOption>
                </div>
              </RadioButton>
            </Participants>

            <Line />

            <Participants>
              <h4>Contribuição</h4>
              <InfoContent>
                <div>
                  {tipCtbAdic === 'P' ? (
                    <p>
                      Contribuição básica ({userDetails.pctContribuicaoBasica}%)
                    </p>
                  ) : (
                    <p>Contribuição básica (máximo)</p>
                  )}
                  <strong>{formatValue(userDetails.contribuicaoBasica)}</strong>
                </div>
                {(userDetails.pctContribuicaoSuplementar > 0 ||
                  userDetails.contribuicaoSuplementar > 0) &&
                tipCtbAdic !== '' ? (
                  <>
                    {tipCtbAdic === 'P' ? (
                      <div>
                        <p>
                          Contribuição adicional (
                          {userDetails.pctContribuicaoSuplementar}%)
                        </p>
                        <strong>
                          {formatValue(
                            userDetails.salario *
                              (userDetails.pctContribuicaoSuplementar / 100),
                          )}
                        </strong>
                      </div>
                    ) : (
                      <div>
                        <p>Contribuição adicional (valor fixo)</p>
                        <strong>
                          {formatValue(userDetails.contribuicaoSuplementar)}
                        </strong>
                      </div>
                    )}
                  </>
                ) : (
                  <></>
                )}
                <button
                  className="edit"
                  type="button"
                  onClick={() => {
                    setFlagEdit('S')
                    goback('S')
                  }}
                >
                  Alterar valores
                </button>
              </InfoContent>
            </Participants>
            <Line />

            <Participants>
              <h4>Beneficiários</h4>
              {participants.length > 0 ? (
                <>
                  <InfoContent>
                    {dependents.map(d => (
                      <div key={Math.random()} className="dependents">
                        <div className="infos">
                          <p>{d.data.name}</p>
                          <small>
                            {d.details.dcrGrauParentesco}
                            {', '}
                            {calculaIdade(d.data.birthdate)}{' '}
                            {calculaIdade(d.data.birthdate) > 1
                              ? 'anos'
                              : 'ano'}
                          </small>
                        </div>
                      </div>
                    ))}
                    <button
                      className="edit"
                      type="button"
                      onClick={() => goback('b')}
                    >
                      Incluir novo beneficiário
                    </button>
                  </InfoContent>
                  <Line />
                </>
              ) : (
                <InfoContent>
                  <div key={Math.random()} className="dependents">
                    <p>Nenhum beneficiário informado.</p>
                  </div>
                  <button
                    className="edit"
                    type="button"
                    onClick={() => goback('b')}
                  >
                    Incluir beneficiário
                  </button>
                </InfoContent>
              )}
            </Participants>
          </Form>
        </Content>
        <Button
          type="button"
          color="orange"
          width="large"
          disabled={!reSend || aguarde}
          onClick={handleConfirmar}
        >
          <span>Confirmar informações</span>
        </Button>
        <BtnVoltar type="button" onClick={() => goback('V')}>
          &lt; Anterior
        </BtnVoltar>

        <ModalBox isOpen={isModalOpen} onRequestClose={handleCloseModal}>
          {warningText}
          <BtnModal isActive onClick={() => handleCloseModal()}>
            Ok
          </BtnModal>
        </ModalBox>
        <ModalBox isOpen={isModalPEPOpen} onRequestClose={handleCloseModalPEP}>
          <strong>Pessoa Exposta Politicamente (PEP)</strong>
          <span>
            São pessoas expostas politicamente (PEP) aqueles eu atualmente ou
            nos últimos 5 anos:
          </span>
          <div>
            <ul>
              <li>
                Detentores de mandatos eletivos dos Poderes Executivo e
                Legislativo da União;
              </li>
              <li>
                Ocupantes de cargo no Poder Executivo da União como ministro de
                Estado ou equiparado, de natureza especial ou equivalente;
              </li>
              <li>
                Presidente, vice-presidente e diretor, ou equivalentes de
                entidades da administração pública indireta;
              </li>
              <li>
                Exercentes de função pública federal com Direção e
                Assessoramento Superiores (DAS), nível 6, ou equivalente;
              </li>
              <li>
                Membros do CNJ, STF, STJ e outros tribunais superiores, TRF,
                TRT, TRE, CSJT e CJF;
              </li>
              <li>Membros do Conselho Nacional do MP;</li>
              <li>Procurador-Geral ou Vice-Procurador-Geral da República;</li>
              <li>Procurador-Geral do Trabalho e/ou da Justiça Militar;</li>
              <li>Subprocuradores-Gerais da República</li>
              <li>
                Procuradores-Gerais de Justiça dos Estados e do Distrito
                Federal;
              </li>
              <li>
                Membros do TCU, Procurador-Geral e/ou Subprocuradores-Gerais do
                MP junto ao TCU;
              </li>
              <li>
                Presidentes e os tesoureiros nacionais ou equivalentes, de
                partidos políticos;
              </li>
              <li>
                Governadores e os secretários de Estados e do Distrito Federal;
              </li>
              <li>Deputados estaduais e distritais;</li>
              <li>
                Presidentes ou equivalentes de entidades da administração
                pública indireta estadual e distrital;
              </li>
              <li>
                Presidentes de Tribunais de Justiça, Tribunais Militares,
                Tribunais de Contas ou equivalentes dos Estados e do Distrito
                Federal;
              </li>
              <li>Prefeitos, os vereadores, os secretários municipais;</li>
              <li>
                Presidentes ou equivalentes de entidades da administração
                pública indireta municipal;
              </li>
              <li>
                Presidentes de Tribunais de Contas ou equivalentes dos
                municípios;
              </li>
              <li>
                Pessoas que, no exterior, sejam chefes de estado ou de governo,
                políticos de escalões superiores, ocupantes de cargos
                governamentais de escalões superiores, oficiais-generais e
                membros de escalões superiores do Poder Judiciário, executivos
                de escalões superiores de empresas públicas ou dirigentes de
                partidos políticos;
              </li>
              <li>
                Dirigentes de escalões superiores de entidades de direito
                internacional público ou privado.
              </li>
            </ul>
          </div>
          <BtnModal isActive onClick={() => handleCloseModalPEP()}>
            Ok
          </BtnModal>
        </ModalBox>
      </Container>
    </>
  )
}

export default Resume
